<template>
  <div class="contents">
    <top></top>
  </div>
</template>
<script>
import top from "./components/top.vue";
export default {
  data() {
    return {};
  },
  mounted() {},
  components: {
    top,
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.card-top {
  width: 100%;
}
</style>
